import React from 'react';
import './detailDeepBoxCompany.css'

const DetailDeepBoxEmployee = ({ title, data }) => {
  return (
    <div className='detail-deep-box-company__container'>
      <h3>{title}</h3>
      <div className="detail-deep-box-company__description-container">
        <p>{data}</p>
      </div>
    </div>
  );
};

export default DetailDeepBoxEmployee;